import Loading from "@/components/general/Loading";
import ScrollToTop from "@/components/general/ScrollToTop";
import UserLayout from "@/layouts/UserLayout";
import { Suspense } from "react";
import { Outlet } from "react-router";

export default function Root() {
  return (
    <ScrollToTop>
      <UserLayout>
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </UserLayout>
    </ScrollToTop>
  );
}
